import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=2bcdc2bf&"
import script from "./DropdownButton.vue?vue&type=script&lang=ts&"
export * from "./DropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports